import { ActionTree } from 'vuex';
import { UsersState, UserProfile } from './models';
import { RootState } from '@/store';
import api from './api';
import { Mutations } from './mutations';
import { ErrorApi } from '@/core/api/ErrorApi';
import Notify from '@/shared/services/Notify/Notify';
import decode from 'jwt-decode';

export enum Actions {
  FETCH_USER_PROFILE = 'FETCH_USER_PROFILE',
}

export const actions: ActionTree<UsersState, RootState> = {

  async [Actions.FETCH_USER_PROFILE]({ commit }, email: string | undefined) {
    if (!(this as any).$auth.isAuthenticated) {
      commit(Mutations.GET_USER_PROFILE_FAILURE);
      Notify.error('Cannot fetch user profile because user is not authenticated!');
    }
    commit(Mutations.GET_USER_PROFILE_REQUEST);
    let innerEmail: string = '';
    if (!email) {
      // console.log((this as any).$auth.user);
      innerEmail = (this as any).$auth.user.email;
    } else {
      innerEmail = email;
    }
    await api.fetchUserProfile(innerEmail).then(
      (payload: UserProfile) => {
        commit(Mutations.GET_USER_PROFILE_SUCCESS, payload);
      },
      (error: ErrorApi) => {
        commit(Mutations.GET_USER_PROFILE_FAILURE);
        Notify.errorApi(error);
      },
    );
  },

};
